define(function(require) {
  var IpsModel = require('civicsBase/ipsModel');
  return IpsModel.extend({
    validation: {
      newPassword: {
        required:true,
        // minLength:6
      },
      oldPassword: {
        required:true
      },
      confirmPassword: {
        equalTo: 'newPassword',
        // minLength:6
      }
    },
    urlRoot: '/delegate/civics-api/api/portal/users/setpassword',
  });
});
